var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-loader"},[_c('p',{staticClass:"sl-top"},[_vm._v("רק רגע...")]),_c('p',{staticClass:"sl-bottom"},[_vm._v("אנחנו טוענים את המוצרים המומלצים שלך")]),_c('Spinner'),_c('div',{staticClass:"bg-img"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }